/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateLegacyProductMutationRequest,
  CreateLegacyProductMutationResponse,
  CreateLegacyProduct400,
} from '../types/CreateLegacyProduct'

function getCreateLegacyProductUrl() {
  const res = { method: 'POST', url: `/api/v1/products/` as const }
  return res
}

/**
 * @summary Create a product (legacy endpoint)
 * {@link /api/v1/products/}
 */
export async function createLegacyProduct(
  data: CreateLegacyProductMutationRequest,
  config: Partial<RequestConfig<CreateLegacyProductMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateLegacyProductMutationResponse,
    ResponseErrorConfig<CreateLegacyProduct400>,
    CreateLegacyProductMutationRequest
  >({
    method: 'POST',
    url: getCreateLegacyProductUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
